<template>
  <generic-modal
    size="small"
    :title="$t('account')"
    icon="file invoice dollar"
    image="/images/icons/accounts.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("type") }}</label>
            <div class="ui selection dropdown" ref="type_dropdown">
              <input type="hidden" name="type" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <div class="field">
            <label for>{{ $t("number") }}</label>
            <div class="ui action input">
              <input
                type="text"
                name="account_number"
                v-model="setup.account_number"
              />
              <button
                class="ui teal right icon button"
                :data-tooltip="$t('generate')"
                v-bind:class="{ disabled: setup.account_number }"
                @click="generate_account_number"
              >
                <i class="lightning icon"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("name") }}</label>
          <input type="text" name="name" v-model="setup.name" />
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
// import GenericContainer from "@/components/GenericContainer";

export default {
  name: "AccountModal",
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  props: { student_uuid: String, account: Object },
  data() {
    return {
      uuid: "",
      setup: {
        account_number: "",
        name: "",
        type: "",
      },
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/account/do-save", {
            i: vm.uuid,
            s: vm.setup,
          })
            .then((account) => {
              vm.$emit("succedded", account);
              resolve();
            })
            .catch((err) => {
              window.jQuery(vm.$refs.form).form("add errors", [err]);
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    generate_account_number() {
      this.setup.account_number = Math.floor(1000000 + Math.random() * 9000000);
    },
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
        account_number: ["empty"],
        type: ["empty"],
      },
    });

    local_api(vm, "post", "/account_type/do-get-list", {})
      .then((accountTypes) => {
        let vls = accountTypes.map((t) => {
          return { name: t.name, value: t.type_id };
        });

        window
          .jQuery(vm.$refs.type_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.setup.type = value;
            },
          });

        if (vm.account && vm.account.type_id) {
          window
            .jQuery(vm.$refs.type_dropdown)
            .dropdown("set selected", vm.account.type_id);
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {},
  updated: function() {},
  created() {
    let vm = this;
    if (vm.student_uuid) {
      local_api(vm, "post", "/student/do-get", {
        u: vm.student_uuid,
      })
        .then((student) => {
          vm.setup = student.setup;
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    }

    if (vm.account && vm.account.name) {
      vm.setup.account_number = vm.account.number;
      vm.setup.name = vm.account.name;
      vm.uuid = vm.account.uuid;
    }
  },
};
</script>
